import { Box } from '@mui/material'
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const logos = [
  { id: 1, name: 'digivito', path: require('../../assets/digivito.png') },
  { id: 2, name: 'wise-wings', path: require('../../assets/wide-wings.png') },
  { id: 3, name: 'coxiant', path: require('../../assets/coxiant.png') },
  { id: 4, name: 'benchmark', path: require('../../assets/benchmark.png') },
  { id: 4, name: 'aithinkinglabs', path: require('../../assets/aithinkinglabs.png') },
  { id: 5, name: 'gardiant', path: require('../../assets/gardiant.jpeg') },
  { id: 6, name: 'bookkeep', path: require('../../assets/bookkeep.png') },
  { id: 7, name: 'vjcs', path: require('../../assets/vjcs.png') },
  { id: 8, name: 'jk-tyre', path: require('../../assets/jk-tyre-seeklogo.png') },
  { id: 9, name: 'assura-protect', path: require('../../assets/assura.png') },
]

const ClientCorousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 500,
    cssEase: "linear",
    centerMode: false,
    variableWidth: true,
    responsive: [
      { breakpoint: 900, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <Box
      sx={{
        overflow: 'hidden',
        '& .slick-track': {
          display: 'flex',
          alignItems: 'center',
        },
        '& .slick-slide': {
          float: 'none',
          height: 'auto',
        },
        '& .slick-slide > div': {
          display: 'flex',
          justifyContent: 'center',
        },
      }}
    >
      <Slider {...settings}>
        {logos.map((item) => (
          <Box
            key={item.id}
            sx={{
              px: { xs: 2, md: 4 },
              boxSizing: 'border-box',
              width: { xs: 140, sm: 170, md: 182 },
            }}
          >
            <Box
              component="img"
              src={item.path}
              alt={item.name}
              sx={{
                height: { xs: 80, sm: 110, md: 150 },
                width: { xs: 100, sm: 130, md: 150 },
                objectFit: 'contain',
                display: 'block',
                mx: 'auto',
              }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  )
}

export default ClientCorousel
